export function formatNumber(value) {
  if (!value) value = 0;
  return Number(value).toLocaleString("pt-br");
}
